var updateSummaryList = function(person,isSelected,uuid){
    if( $.inArray(person,ignoreLegend) == -1 ){
        if(isSelected){
            var legend = $("input[id='member-"+uuid+"']").prop("legend");
            $("#summary-respondents-list").append(
                '<div class="summary-respondent" legend="'+legend+'" id="summary-'+uuid+'">'+
                person+
                '</div>'
            );
        }else{
            $("#summary-"+uuid).remove();
        }
    }
};

var setTabState = function(uuid,makeActive){

    if(makeActive){
        //We are adding this person to the report.
        //Make this tab the active one
        $('#nav-' + uuid ).prop('hidden',false);
        $('.nav-tabs a[href="#tab-' + uuid + '"]').tab('show');
    }else{
        //We are subtracting this person from the report.
        //But is their tab currently the active one in view?
        var isCurrentActiveTab = $('#tab-' + uuid ).hasClass('active');
        if(isCurrentActiveTab){
            // find candidate tab to become active
            $(".report-tabs-nav").each(function(){
                if(!$(this).hasClass('active')){
                    //inactivate and hide the tab being hidden
                    $('#tab-' + uuid ).removeClass('active show');
                    //activate and format the tab being shown
                    $(this).tab('show');
                    return;
                }
            });
        }
        //Now, hide the subtracted person's tab
        $('#nav-' + uuid ).prop('hidden',true);
    }

    var numTabs = $("input[name='members[]']:checked").length;

    $('.report-tabs-nav').removeClass('solo');
    if(numTabs==0){
        $("#report-card-tabs").fadeOut(500);
    }else{
        if(numTabs==1){
            $('.report-tabs-nav').removeClass('active').addClass('solo');
        }
        $("#report-card-tabs").fadeIn(500);
    }

};

$(document).ready( function() {

    if (!$().select2) {
        console.warn('Warning - select2.min.js is not loaded.');
        return;
    }

    $('#configurator-assessments').on('change',function(){
        window.location.href = baseUrl+doneSlug[$(this).val()];
    });

});
